module.exports = __webpack_public_path__ + "static/media/logo-prohace.e495529d.png";